import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../client/APIMethodKeys';
import { GlobalContext } from '../contexts/GlobalContext';
const usePlansMaxRetention = () => {
  const $ = _c(8);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.billing.getPlans();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.billing) {
    t1 = () => HookdeckAPI.billing.getPlans();
    $[1] = HookdeckAPI.billing;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: plans
  } = useSWR(t0, t1);
  if (!plans) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        max_retention_days: undefined
      };
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== plans) {
    t2 = plans.reduce(_temp, 0);
    $[4] = plans;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const max_retention_days = t2;
  let t3;
  if ($[6] !== max_retention_days) {
    t3 = {
      max_retention_days
    };
    $[6] = max_retention_days;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default usePlansMaxRetention;
function _temp(max, plan) {
  const retention_days = Number(plan.metadata?.retention_days || 0);
  return retention_days > max ? retention_days : max;
}